import { useCallback } from 'react';
import { usePlatformAuth } from '../contexts/AuthContext';
import { Account, TaskDefinitionSummary } from '../types';
import { api } from '../services/api';

export const useTemplateManagement = (
  currentAccount: Account,
  setCurrentAccount: (account: Account) => void,
  setTemplates: (templates: TaskDefinitionSummary[]) => void
) => {
  const auth = usePlatformAuth();

  const handleTemplateAdded = useCallback(async () => {
    if (!auth.isAuthenticated) return;
    try {
      // Fetch the latest account (with updated eligibleTasks)
      const stripeConnectedAccountId = currentAccount.stripeConnectedAccountId;
      const updatedAccount = await api.getAccount(stripeConnectedAccountId);
      setCurrentAccount(updatedAccount);
      // Fetch only eligible task definitions
      let fetchedTemplates: TaskDefinitionSummary[] = [];
      if (updatedAccount.eligibleTasks && updatedAccount.eligibleTasks.length > 0) {
        fetchedTemplates = await api.getTaskDefinitionsBatch(updatedAccount.eligibleTasks);
      }
      setTemplates(fetchedTemplates);
    } catch (err) {
      console.error('Error refreshing templates/account:', err);
    }
  }, [auth.isAuthenticated, currentAccount, setCurrentAccount, setTemplates]);

  const fetchTemplates = useCallback(async () => {
    if (!auth.isAuthenticated || !currentAccount) return;
    try {
      let fetchedTemplates: TaskDefinitionSummary[] = [];
      if (currentAccount.eligibleTasks && currentAccount.eligibleTasks.length > 0) {
        fetchedTemplates = await api.getTaskDefinitionsBatch(currentAccount.eligibleTasks);
      }
      setTemplates(fetchedTemplates);
    } catch (err) {
      console.error('Error fetching templates:', err);
      throw new Error('Failed to load templates. Please try again.');
    }
  }, [auth.isAuthenticated, currentAccount, setTemplates]);

  return {
    handleTemplateAdded,
    fetchTemplates,
  };
}; 